import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import it from './locales/it.json';
import en from './locales/en.json';
import de from './locales/de.json';
import ar from './locales/ar.json';

i18n?.use(initReactI18next)?.init({
    resources: {
      fr: { translation: fr },
      it: { translation: it },
      en: { translation: en },
      de: { translation: de },
      ar: { translation: ar },
    },
    lng: 'fr',
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en', 'it', 'de', 'ar'],
    interpolation: { escapeValue: false },
  });

// Direction listener: flip <html dir="rtl"> when language changes
i18n?.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  }
});

// Initial direction (covers refresh with persisted lang)
if (typeof document !== 'undefined') {
  const initialLng = i18n.language || 'fr';
  document.documentElement.dir = initialLng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = initialLng;
}

export default i18n;
